/**
 * Angular imports.
 */
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

/**
 * For the image type stories.
 */
@Component({
  selector: 'app-story-image',
  templateUrl: './story-image.component.html',
  styleUrls: ['./story-image.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StoryImageComponent {

  /**
   * Src for the story.
   */
  @Input() readonly src: string;
}
